import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Reveal } from "../components/Reveal";
import { ArrowUpRight } from "lucide-react";

const CAT_LABEL = { rims: "Rims", tires: "Tires", suspension: "Suspension" };

export default function Brands() {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    api.get("/brands").then((r) => setBrands(r.data)).catch(() => {});
  }, []);

  const grouped = brands.reduce((acc, b) => {
    (acc[b.category] = acc[b.category] || []).push(b);
    return acc;
  }, {});

  return (
    <div className="pt-24 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.3em] text-[#00f0ff]">The Roster</span>
          <h1 className="font-display text-6xl md:text-8xl uppercase leading-none mt-3">Brand <span className="bttf-text">Directory</span></h1>
          <p className="text-zinc-400 max-w-lg mt-4">Only the rim, tire, and suspension names that earn their spot on serious builds.</p>
        </Reveal>

        <div className="mt-16 space-y-16">
          {["rims", "tires", "suspension"].map((cat) => (
            grouped[cat] ? (
              <div key={cat}>
                <div className="flex items-baseline gap-4 mb-6 border-b border-[#27272a] pb-3">
                  <h2 className="font-display text-3xl md:text-4xl uppercase">{CAT_LABEL[cat]}</h2>
                  <span className="text-sm text-zinc-500">{grouped[cat].length} brands</span>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {grouped[cat].map((b, i) => {
                    const comingSoon = b.status === "coming_soon";
                    const inner = (
                      <>
                        <div>
                          <div className={`font-display text-2xl uppercase leading-none transition-colors ${comingSoon ? "text-zinc-500" : "group-hover:text-[#00f0ff]"}`}>{b.brand}</div>
                          {comingSoon ? (
                            <div className="text-[10px] uppercase tracking-[0.2em] text-[#ff6a00] mt-2">Coming Soon</div>
                          ) : (
                            <div className="text-xs text-zinc-500 mt-1">{b.count} {b.count === 1 ? "product" : "products"}</div>
                          )}
                        </div>
                        <ArrowUpRight size={20} className={comingSoon ? "text-zinc-700" : "text-zinc-600 group-hover:text-[#00f0ff] transition-colors"} />
                      </>
                    );
                    return comingSoon ? (
                      <Reveal key={b.brand} delay={(i % 4) * 0.05}>
                        <div
                          data-testid={`brand-${b.brand.replace(/\s+/g, "-")}`}
                          className="flex items-center justify-between border border-dashed border-[#27272a] p-5 h-full opacity-70 cursor-default"
                        >
                          {inner}
                        </div>
                      </Reveal>
                    ) : (
                      <Reveal key={b.brand} delay={(i % 4) * 0.05}>
                        <Link
                          to={`/search?q=${encodeURIComponent(b.brand)}`}
                          data-testid={`brand-${b.brand.replace(/\s+/g, "-")}`}
                          className="group flex items-center justify-between border border-[#27272a] p-5 h-full hover:border-[#00f0ff] card-glow transition-all"
                        >
                          {inner}
                        </Link>
                      </Reveal>
                    );
                  })}
                </div>
              </div>
            ) : null
          ))}
        </div>
      </div>
    </div>
  );
}
